import Tooltip from "@components/dashboard/tooltip";
import { useTitleAnnulments } from "./TitleAnnulmentsContext";
import { brl, isPending, PENDING_TEXT, totalsForItem, totalsOf, hasAnnulments } from "./summary";

// Ícone padrão ao lado de todo valor de pago / a pagar de uma obra com título anulado (design
// D6). Dados vindos só de `activeProject.titleAnnulments` (nenhuma chamada nova). Passar o
// mouse ou focar com o teclado mostra o tooltip; clicar (ou Enter/Espaço) abre a barra lateral.
//   kind: "toPay" | "paid" | "both" -- o que o tooltip diz ter saído do valor da tela.
//   placement="chart": fixa o ícone no canto superior direito do gráfico (legenda do chart.js é canvas).
//   placement="row": linha própria alinhada à direita, logo acima de um gráfico sem canto posicionado.
//   wbsCode: valor de um item da EAP; filtra os títulos por prefixo do código da EAP (`matchingAnnulledTitles`).

const NORMAL_COLOR = "#d9534f";
const PENDING_COLOR = "#EF9F27";

export const indicatorText = ({ count, toPay, paid }, kind = "both") => {
  const head = `${count} ${count === 1 ? "título anulado" : "títulos anulados"} na Ampli fora deste valor`;
  const parts = [head];
  if (kind !== "paid") parts.push(`A pagar: ${brl(toPay)}`);
  if (kind !== "toPay") parts.push(`Pago: ${brl(paid)}`);
  return parts.join(" · ");
};

// Ícone + tooltip sem dado nenhum: o visual do indicador, para quem tem a própria fonte de
// números (a Diretoria lê o resumo em centavos, sem obra) e escolhe o que o clique faz.
export const AnnulmentIcon = ({ message, pending = false, onClick, placement }) => (
  <span
    className={`annulment-indicator${pending ? " annulment-indicator--pending" : ""}${placement === "chart" ? " annulment-indicator--chart" : ""}${placement === "row" ? " annulment-indicator--row" : ""}`}
    data-testid="annulment-indicator"
    data-variant={pending ? "pending" : "normal"}
  >
    <Tooltip
      message={message}
      ariaLabel={message}
      onClick={onClick}
      boxClassName="right"
    >
      <i
        className="icon icon-width-16 icon-ban"
        aria-hidden="true"
        style={{ background: pending ? PENDING_COLOR : NORMAL_COLOR }}
      />
    </Tooltip>
  </span>
);

const AnnulmentIndicator = ({ summary, kind = "both", wbsCode, placement }) => {
  const { openOffcanvas } = useTitleAnnulments();
  if (!hasAnnulments(summary)) return null;
  const pending = isPending(summary);
  const filtered = wbsCode !== undefined && wbsCode !== null;
  const totals = filtered ? totalsForItem(summary, wbsCode) : totalsOf(summary);
  // Valor de item sem título apropriado nele: sem indicador (nem o da pendência, que é da obra).
  if (filtered && totals.count === 0) return null;
  const normal = totals.count > 0 ? indicatorText(totals, kind) : null;
  const message = pending ? [PENDING_TEXT, normal].filter(Boolean).join(" ") : normal;
  if (!message) return null;
  return <AnnulmentIcon message={message} pending={pending} onClick={openOffcanvas} placement={placement} />;
};

export default AnnulmentIndicator;
